"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowGoto = function ArrowGoto() {
  return _react2.default.createElement(
    "g",
    { id: "icon_arrow" },
    _react2.default.createElement("polygon", {
      id: "Combined-Shape",
      points: "417 226.9 0 226.9 0 272.8 417 272.8 323.1 371.5 353.7 403.6 500 249.8 353.7 96 323.1 128.1"
    })
  );
};

exports.default = ArrowGoto;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowGoto.js
// module id = 2923
// module chunks = 4